import {
  gsap
} from 'gsap';
import Headroom from 'headroom.js';
import {
  headerHeight,
  throttle,
  isTemplate,
  updateHeaderHeightVars,
  loadsSection
} from '../helpers';
import {
  openMinicart
} from './minicart';

if (!window.dAgency) window.dAgency = {};

(function ($) {
  const $siteHeader = $('.site-header');
  const $pageContainer = $('#PageContainer');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0) return false;

  const closeMenu = function (e, $currentMenu) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    if ($(window).outerWidth() <= 1024) return;


    $header.removeClass('force-opacity');
    if ($currentMenu && $currentMenu.length) {
      $currentMenu.removeClass('open');
      $currentMenu.find('.open').removeClass('open');
    } else {
      const $currentOpenedMenu = $header.find('.open');

      $currentOpenedMenu.removeClass('open');
      $currentOpenedMenu.find('.open').removeClass('open');
    }

    $('html').removeClass('menu--open');
    $('html').css('overflow-y', '');
    $(document).trigger("dAgency:menuClosed");
  };

  const openMenu = function (e, $currentMenu) {
    e.stopPropagation();
    e.stopImmediatePropagation();

    if ($(window).outerWidth() <= 1024 || $(e.target).closest('.country-switcher').length) return;

    $('html').addClass('menu--open');
    $header.addClass('force-opacity');

    if ($currentMenu && $currentMenu.length) {
      $currentMenu.addClass('open');
    }

    $('html').css('overflow-y', 'hidden');
    $(document).trigger("dAgency:menuOpened");
  }

  $(document).on('dAgency:menuClose', e => {
    closeMenu(e);
  });

  $('.scrim').on('click', e => closeMenu(e));

  window.addEventListener('resize', throttle(updateHeaderHeightVars, 100)); // onresize
  updateHeaderHeightVars(); // onload

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $pageContainer.css(
    'min-height',
    'calc(100vh - ' + headerHeight() + 'px)',
  );
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $pageContainer.css(
      'min-height',
      'calc(100vh - ' + headerHeight() + 'px)',
    );
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector('header.site-header');
  let prevScrollY = 0;
  let headroomStartOffset = 0;
  let stickOffset = $siteHeader.outerHeight();
  let animationSpeed = 700;
  let headroomTolerance = 20;

  if (loadsSection('template-multicollection')) {
    const collectionOffset = $('.collection-wrapper').offset().top;
    stickOffset = collectionOffset;
    animationSpeed = 400;
    headroomTolerance = 0;
  }

  if (header) {
    const options = {
      offset: {
        down: headroomStartOffset,
      },
      tolerance: {
        up: headroomTolerance,
        down: 0,
      },
      onPin: function () {
        window.requestAnimationFrame(() => {
          document.documentElement.classList.remove('headroom--unpin-root');
          document.documentElement.classList.add('headroom--pin-animate-out', 'headroom--pin-root');
        });
      },
      onUnpin: function () {
        window.requestAnimationFrame(() => {
          document.documentElement.classList.remove('headroom--pin-root');
          document.documentElement.classList.add('headroom--unpin-root');
        });
        window.setTimeout(() => {
          window.requestAnimationFrame(() => document.documentElement.classList.remove('headroom--pin-animate-out'));
          }, animationSpeed);
        }
    };

    const headroom = new Headroom(header, options);
    headroom.init();

    /* ======================== Header ======================== */
    const toggleTransparency = function (activate) {
        if ($header.hasClass('header__transparent') && !$header.hasClass('force-opacity')) {
          if (activate) {
            $header.addClass('apply-transparency');
          } else {
            $header.removeClass('apply-transparency');
          }
      }
      }


      $(document, window).on('scroll', throttle(function () {
        if (window.scrollY > stickOffset && window.scrollY > prevScrollY) {
          $('html').addClass('headroom--stick');
          toggleTransparency(false);
          } else if (window.scrollY <= stickOffset && window.scrollY <= headroomStartOffset) {
            $('html').removeClass('headroom--stick');

          toggleTransparency(true);

        } else if (window.scrollY <= stickOffset) {
          $('html').removeClass('headroom--pin-animate-out');
        }

        prevScrollY = window.scrollY;
      }, 100));
  }

  $header.on('mouseenter', function () {
    if ($(window).outerWidth() > 1024) {
      $header.removeClass('apply-transparency');
    }
  });
  $header.on('mouseleave', function () {
    if (
      $(window).scrollTop() === 0 &&
      $(window).outerWidth() > 1024 &&
      !$header.hasClass('force-opacity')
    ) {
      $header.addClass('apply-transparency');
    }
  });

  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof window.dAgency.showNewsletterPopUp === 'function')
      window.dAgency.showNewsletterPopUp();
  });

  const $cartLink = $header.find('.cart-link');
  if ($cartLink.length) {
    $cartLink.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openMinicart();
    });
  }

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  var isMenuOpen = false;
  if ($mobileMenu.length > 0) {
    $mobileMenu.css('height', '100vh');

    if ($mobileMenu.hasClass('header__mobile-menu--dropdown')) {
      $mobileMenu.find('[data-link-opener]').on('click', function (e) {
        if (e.target.getAttribute('href')) return;

        const drawerAttribute = $(this).data('link-opener');
        const $drawer = $(this)
          .parent()
          .find('[data-level="' + drawerAttribute + '"]');
        if ($drawer.length > 0) {
          $drawer.addClass('open');
        }
      });

      $mobileMenu.find('[data-close-level]').on('click', function () {
        $(this).parent().removeClass('open');
      });

      const $menuCarousel = $mobileMenu.find(
        '.header__mobile-menu--dropdown__footer__carousel__blocks',
      );
      if ($menuCarousel.length > 0) {
        if ($menuCarousel[0].scrollWidth <= $menuCarousel[0].clientWidth) {
          $menuCarousel.css('justify-content', 'center');
        } else {
          window.dAgency.initDesktopSlider($menuCarousel[0], 2);
        }
      }
    } else if ($mobileMenu.hasClass('header__mobile-menu--drawer')) {
      const $close = $mobileMenu.find('.header__mobile-header-close');
      $close.on('click', function () {
        menuToggle();
        menuClose();
      })

      const $firstLevel = $mobileMenu.find(
        '.header__mobile-menu--drawer__first-level__title',
      );
      $firstLevel.each(function () {
        const submenu = $(this).data('submenu');
        const $connectedSecondLevel = $mobileMenu.find(
          '.header__mobile-menu--drawer__second-level[data-submenu="' +
          submenu +
            '"]',
        );
        $(this).on('click', function (e) {
          if (
            e.target.getAttribute('href') ||
            $connectedSecondLevel.find(
              '.header__mobile-menu--drawer__second-level__title',
            ).length <= 0
          )
            return;

          $connectedSecondLevel.addClass('open');
        });
      });

      const $secondLevel = $mobileMenu.find(
        '.header__mobile-menu--drawer__second-level',
      );
      $secondLevel.each(function () {
        const $level = $(this);
        const $close = $(this).find(
          '.header__mobile-menu--drawer__second-level__close',
        );
        $close.on('click', function () {
          $level.removeClass('open');
        });
      });
    }
    const menuToggle = function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
    }

    const menuClose = function () {
      window.requestAnimationFrame(function () {
        console.log('menu-close');
        $('html').removeClass('menu--open');
      });
        $header.removeClass('apply-transparency');
        $header.addClass('force-opacity');
    }

    const menuOpen = function () {
      window.requestAnimationFrame(function () {
        console.log('menu-open');
        $('html').addClass('menu--open');
      });

        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
    }

    $header.find('.header__burger-icon').on('click', function () {
          if (isMenuOpen) {
            menuClose();
          } else {
            menuOpen();
          }
        menuToggle();
    });

    const $mobileMenuImages = $('.header__mobile-menu__level__image');
    if ($mobileMenuImages.length > 0) {
      $mobileMenuImages.each(function () {
        const $links = $(this).prev();
        $links.css(
          'height',
          'calc(100% - ' + $(this).innerHeight() + 'px - 1rem)',
        );
      });
    }

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css(
          'transform',
          'translate3d(0, 0, 0)',
        );
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on(
      'click',
      function () {
        const $menu = $(this).closest('.header__mobile-menu__level');
        $menu.css('transform', '');
      },
    );
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  if ($desktopMenu.length > 0) {
    if ($desktopMenu.hasClass('header__desktop-menu--dropdown')) {
      const $dropdownInlineElements = $desktopMenu.find(
        '.header__desktop-menu--dropdown__inline-elements__link',
      );
      $dropdownInlineElements.each(function () {
        if (
          $desktopMenu.hasClass(
            'header__desktop-menu--dropdown--alternative',
          ) &&
          $(this).find('.header__desktop-menu--dropdown__navigation__element')
          .length <= 0
        )
          return;

        $(this).on('mouseenter', function () {
          $(this)
            .find('.header__desktop-menu--dropdown__dropdown-wrapper')
            .addClass('open');
          $header.addClass('force-opacity');
        });

        $(this).on('mouseleave', function () {
          $(this)
            .find('.header__desktop-menu--dropdown__dropdown-wrapper')
            .removeClass('open');
          $header.removeClass('force-opacity');
        });
      });

      if (
        $desktopMenu.hasClass('header__desktop-menu--dropdown--alternative')
      ) {
        const $sliders = $desktopMenu.find(
          '.header__desktop-menu--dropdown__navigation',
        );
        $sliders.each(function () {
          window.dAgency.initDesktopSlider(this, 2);
        });
      } else {
        $desktopMenu
          .find('.header__desktop-menu--dropdown__navigation')
          .each(function () {
            const $mediaContainer = $(this).find(
              '.header__desktop-menu--dropdown__navigation__media',
            );
            const $titleWithImages = $(this).find('[data-image-src]');

            $titleWithImages.on('mouseenter', function () {
              const imgSrc = $(this).data('image-src');
              const $img = $mediaContainer.find('[srcset*="' + imgSrc + '"]');

              $mediaContainer
                .find(
                  '.header__desktop-menu--dropdown__navigation__media__img.active',
                )
                .removeClass('active');
              $img.addClass('active');
            });
          });

        const $menuCarousel = $desktopMenu.find(
          '.header__desktop-menu--dropdown__carousel__blocks',
        );
        if ($menuCarousel.length > 0) {
          $menuCarousel.each(function () {
            const slider = $(this)[0];
            if (slider.scrollWidth <= slider.clientWidth) {
              $(this).css('justify-content', 'center');
            } else {
              window.dAgency.initDesktopSlider(slider, 2);
            }
          });
        }
      }
    } else if ($desktopMenu.hasClass('header__desktop-menu--drawer')) {
      const $firstLevelLinks = $desktopMenu.find(
        '.header__desktop-menu--drawer__inline-elements__link',
      );
      $firstLevelLinks.each(function () {
        const $currentMenu = $(this);
        if ($currentMenu.hasClass('header__desktop-menu--drawer__inline-elements__link--has-children')) {
          $currentMenu.on('click', e => openMenu(e, $currentMenu));
          $currentMenu.on('click', '.btn-close', e => closeMenu(e, $currentMenu));
        }
      });

      $desktopMenu
        .find('.header__desktop-menu--drawer__second-level')
        .each(function () {
          $(this).css('height', '100vh');

          const $level = $(this);
          $(this)
            .find(
              '.header__desktop-menu--drawer__second-level__title.clickable',
            )
            .on('click', function (e) {
              if (e.target.getAttribute('href')) return;

              const levelIndex = $(this).data('submenu');
              $level
                .find(
                  '.header__desktop-menu--drawer__third-level[data-submenu="' +
                  levelIndex +
                    '"]',
                )
                .addClass('open');
            });
        });
    }
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $deskSearchBar = $header.find('.header__search-popup');
  if ($deskSearchBar.length > 0) {
    $deskSearchBar.css('top', headerHeight() + 'px');

    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0) {
      $iconSearch.on('click', function (e) {
        e.preventDefault();
        $deskSearchBar.toggleClass('open');

        if ($deskSearchBar.hasClass('open')) {
          $header.removeClass('apply-transparency');
          $header.addClass('force-opacity');
          $deskSearchBar.find('form input[type="text"]').trigger('focus');
        } else {
          $header.removeClass('force-opacity');
          if ($(window).scrollTop() === 0) {
            $header.addClass('apply-transparency');
          }
        }
      });
    }

    $(window).on('resize', function () {
      if ($(window).outerWidth() <= 1024) {
        $header.removeClass('force-opacity');
        $deskSearchBar.removeClass('open');

        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      } else {
        $deskSearchBar.css('top', headerHeight() + 'px');
      }
    });

    const $closeIcon = $deskSearchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $deskSearchBar.removeClass('open');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
      });
    }
  }
})(jQuery);
